class Pagador {
    constructor(
        public key: number = 0,
        public id: number = 0,
        public nom: string = "",
        public cognoms: string = "",
        public telefon: string = "",
        public telefon2: string = "",
        public telefon3: string = "",
        public email: string = "",
        public direccio: string = "",
        public dni: string = "",
        public pagador: boolean = false,
        public iba1: string = "",
        public quota: number = 100,
        public autoritzat: number = 0,
        public creacio: string = "",
        public metalic: boolean = false,
        public iba2: string = "",
        public iba3: string = "",
        public iba4: string = "",
        public iba5: string = "",
        public parentesc: string = "",
        public modificacio: string = "",
        public estat: number = 0
    ) {}
}

export default Pagador;
